import {Injectable, isDevMode} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";
import {LogementService} from "../services/logement.service";
import {ToastService} from "../services/toast.service";
import {UserService} from "../services/user.service";

@Injectable({
  providedIn: 'root'
})
export class ProprietaireGuard  {

  constructor(private logementService: LogementService,
              private router: Router,
              private toastService: ToastService,
              private userService: UserService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return this.logementService.logementCourant.pipe(map(logement => {
      if (!this.userService.hasRoleProprietaire(logement)) {
        if (isDevMode()) {
          console.warn("Vous n'êtes pas le propriétaire de ce logement !");
        }
        this.toastService.show('Accès refusé', {classname: 'toast-error'});
        this.router.navigate(['/accueil']);
      }
      return logement.userPermissions.updatable;
    }));
  }
}
